import ShadowPricetagDefs from "../../components/pictures/ShadowPricetagDefs";

export default function SvgPriceTag({gapSize, showHole = true, text = '', doShadow}) {
    const dynamicImageWidth = 80 + gapSize * 2;
    const dynamicViewBox = `0 0 ${40 + gapSize} 20`;
    const dynamicTransform = `translate(${gapSize}, 0)`;
    const dynamicWidth = 10 + gapSize;
    const path = `
    M36.7547 1.70782
    C36.4146 1.36381 36.0095 1.09091 35.5629 0.905013
    C35.1163 0.719113 34.6372 0.62393 34.1535 0.625009
    L24.0694 0.625009
    C23.4079 0.626242 22.7736 0.888283 22.3041 1.35427
    L2.14488 21.5093
    C1.457 22.1986 1.07068 23.1327 1.07068 24.1065
    C1.07068 25.0803 1.457 26.0143 2.14488 26.7036
    L11.7425 36.3012
    C12.432 36.9894 13.3663 37.3759 14.3405 37.3759
    C15.3146 37.3759 16.2489 36.9894 16.9384 36.3012
    L37.0894 16.1543
    C37.5563 15.6856 37.8192 15.0515 37.8211 14.3899
    V4.30001
    C37.8241 3.81881 37.7313 3.34182 37.5482 2.8968
    C37.3652 2.45178 37.0954 2.04762 36.7547 1.70782
    Z `;

    const pathWithHole = path + `
      M29.9461 11.125
      C29.4269 11.125 28.9194 10.9711 28.4877 10.6826
      C28.056 10.3942 27.7196 9.98421 27.5209 9.50455
      C27.3222 9.0249 27.2702 8.4971 27.3715 7.9879
      C27.4728 7.4787 27.7228 7.01097 28.0899 6.64385
      C28.457 6.27674 28.9248 6.02673 29.434 5.92545
      C29.9432 5.82416 30.471 5.87614 30.9506 6.07482
      C31.4303 6.2735 31.8403 6.60996 32.1287 7.04164
      C32.4171 7.47332 32.5711 7.98083 32.5711 8.50001
      C32.5711 9.1962 32.2945 9.86388 31.8022 10.3562
      C31.31 10.8484 30.6423 11.125 29.9461 11.125
      Z`;


    return (
        <svg width={dynamicImageWidth} height="40" viewBox={dynamicViewBox} xmlns="http://www.w3.org/2000/svg">
            <defs>
                {doShadow && <ShadowPricetagDefs/>}
                <clipPath id="leftClip">
                    <rect x="0" y="0" width="20" height="100"/>
                </clipPath>
                <clipPath id="rightClip">
                    <rect x="20" y="0" width="145" height="100"/>
                </clipPath>
            </defs>

            <g filter={doShadow ? "url(#shadow_pricetag)" : undefined}>
                <g clipPath="url(#leftClip)" transform="translate(0, 0)">
                    <svg width="39" height="20" viewBox="0 9 45 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d={path}
                            fill="#266F2D"
                            transform="rotate(45 19.5 19)"
                        />
                    </svg>
                </g>

                <g clipPath="url(#rightClip)" transform={dynamicTransform}>
                    <svg width="39" height="20" viewBox="0 9 45 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d={showHole ? pathWithHole : path}
                            fill="#266F2D"
                            transform="rotate(45 19.5 19)"
                        />
                    </svg>
                </g>
                <rect x="11" y="0.9" width={dynamicWidth} height="18.14" fill="#266F2D"/>
            </g>

            {/* Render the text in white, aligned so its right edge is 34px from the right */}
            <text
                x={gapSize + 23.5}
                y="11.5"
                fill="white"
                textAnchor="end"
                alignmentBaseline="middle"
                style={{fontFamily: 'sans-serif', fontSize: '11px'}}
            >
                {text}
            </text>
        </svg>
    );
}
